module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full"
  }, [(_vm.allKip) ? _c('div', [_c('h1', {
    staticClass: "tit"
  }, [_vm._v(_vm._s(_vm.chapterNum))]), _vm._v(" "), _c('swiper', {
    staticClass: "allContent",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.oneLevel), function(items, sign) {
    return _c('swiper-slide', {
      key: items,
      staticClass: "content",
      class: {
        'isContent': !_vm.isChapter[sign]
      }
    }, [_c('h2', {
      staticClass: "oneLevel"
    }, [_c('span', {
      staticClass: "oneLevelSign"
    }, [_vm._v(_vm._s(_vm.oneLevel[sign]))])]), _vm._v(" "), _c('ul', {
      staticClass: "kpNumList"
    }, [_vm._l((_vm.chapters[sign]), function(chapterList, index) {
      return (_vm.isChapter[sign]) ? _c('li', {
        staticClass: "twoLevel"
      }, [_c('div', {
        staticClass: "twoLevelTit",
        on: {
          "click": function($event) {
            _vm.deploy(sign, index)
          }
        }
      }, [_c('span', {
        staticClass: "kpList"
      }, [_vm._v(_vm._s(chapterList))]), _vm._v(" "), _c('span', {
        staticClass: "knowNum"
      }, [_vm._v("（" + _vm._s(_vm.knowNum[sign][index]) + "个" + _vm._s(_vm.iserrorknow) + "）")]), _vm._v(" "), (_vm.isDeploy[sign][index]) ? _c('img', {
        staticClass: "small",
        attrs: {
          "src": require("../../assets/img/team/btn_downarrow@2x.png")
        }
      }) : _vm._e(), _vm._v(" "), (!_vm.isDeploy[sign][index]) ? _c('img', {
        staticClass: "small",
        attrs: {
          "src": require("../../assets/img/team/btn_uparrow@2x.png")
        }
      }) : _vm._e()]), _vm._v(" "), _c('ul', _vm._l((_vm.chapterChild[sign][index]), function(chapterChildList, num) {
        return (_vm.isDeploy[sign][index]) ? _c('li', {
          staticClass: "deploy"
        }, [_c('a', {
          staticClass: "everyDetails",
          on: {
            "click": function($event) {
              _vm.openStaskLink(_vm.env.URL_WEB_M + '/page/mobile/s/knowpoint-card-detail.html?id=' + chapterChildList.kpCode)
            }
          }
        }, [_c('span', {
          staticClass: "everyChapterList"
        }, [_vm._v(_vm._s(chapterChildList.kpName))]), _vm._v(" "), (chapterChildList.doCount !== '0') ? _c('span', {
          staticClass: "alChapterList"
        }, [_vm._v("已练" + _vm._s(chapterChildList.doCount) + "题")]) : _c('span', {
          staticClass: "alChapterList"
        }), _vm._v(" "), _c('span', {
          class: _vm.cGclass[sign][index][num]
        }, [_vm._v(_vm._s(_vm.cGrade[sign][index][num]))])])]) : _vm._e()
      })), _vm._v(" "), (_vm.isDeploy[sign][index] && _vm.isWeekCodes[sign][index].length) ? _c('ul', {
        staticClass: "twoLevelContent",
        on: {
          "click": function($event) {
            _vm.changeLearn(sign, index)
          }
        }
      }, [_c('li', [_c('div', {
        staticClass: "weakPoint weakTwo"
      }, [_c('div', {
        staticClass: "arrowCon1"
      }, [_vm._v("本节薄弱知识点针对性练习\n                                        "), _c('img', {
        staticClass: "arrow1",
        attrs: {
          "src": require("../../assets/img/team/arrow.png")
        }
      })])])])]) : _vm._e(), _vm._v(" "), (_vm.isDeploy[sign][index] && !_vm.isWeekCodes[sign][index].length) ? _c('ul', {
        staticClass: "twoLevelContent"
      }, [_c('li', [_c('div', {
        staticClass: "weakPoint weakTwo weakEdit"
      }, [_c('div', {
        staticClass: "arrowCon1"
      }, [_vm._v("本节暂无薄弱知识点\n                                    ")])])])]) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.noChapter[sign]), function(noChapterList, index) {
      return (!_vm.isChapter[sign]) ? _c('li', {
        staticClass: "noTwoLevel"
      }, [_c('a', {
        staticClass: "everyDetails",
        on: {
          "click": function($event) {
            _vm.openStaskLink(_vm.env.URL_WEB_M + '/page/mobile/s/knowpoint-card-detail.html?id=' + _vm.kpCode[sign][index])
          }
        }
      }, [_c('span', {
        staticClass: "kpList"
      }, [_vm._v(_vm._s(noChapterList))]), _vm._v(" "), (_vm.kpNum[sign][index] !== '0') ? _c('span', {
        staticClass: "doCount"
      }, [_vm._v("已练" + _vm._s(_vm.kpNum[sign][index]) + "题")]) : _c('span', {
        staticClass: "doCount"
      }), _vm._v(" "), _c('span', {
        staticClass: "rev",
        class: _vm.gclass[sign][index]
      }, [_vm._v(_vm._s(_vm.grade[sign][index]))])])]) : _vm._e()
    }), _vm._v(" "), (!_vm.isChapter[sign] && _vm.isChapterWeek[sign].length) ? _c('div', {
      staticClass: "weakPoint",
      on: {
        "click": function($event) {
          _vm.openLearn(sign)
        }
      }
    }, [_c('div', {
      staticClass: "arrowCon"
    }, [_vm._v("本节薄弱知识点针对性练习\n                            "), _c('img', {
      staticClass: "arrow",
      attrs: {
        "src": require("../../assets/img/team/arrow.png")
      }
    })])]) : _vm._e(), _vm._v(" "), (!_vm.isChapter[sign] && !_vm.isChapterWeek[sign].length) ? _c('div', {
      staticClass: "weakPoint weakEdit"
    }, [_c('div', {
      staticClass: "arrowCon"
    }, [_vm._v("本节暂无薄弱知识点\n                        ")])]) : _vm._e()], 2)])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2), _vm._v(" "), (_vm.isMessage) ? _c('message', {
    attrs: {
      "message": _vm.classMessage
    }
  }) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9eb36eca", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9eb36eca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/details/report.vue
// module id = 393
// module chunks = 6